import { Trans } from '@lingui/react/macro';
import { BadgePlus } from 'lucide-react';
import { memo } from 'react';

import { useChatRenderer } from '../../../ChatRendererProvider';
import { Markdown } from '../../../Markdown';
import { Message } from '../../../ui';

type MembershipPauseProps = {
  pause: {
    content: string;
    showPauseMembershipButton: boolean;
  };
};

export const MembershipPause = memo(function MembershipLogin({
  pause,
}: MembershipPauseProps) {
  const { content, showPauseMembershipButton } = pause;
  const { navigate, isEfitnessAuthenticated } = useChatRenderer();

  return (
    <Message.BubbleGroup>
      <Message.Bubble>
        <Markdown>{content}</Markdown>
      </Message.Bubble>
      {showPauseMembershipButton && isEfitnessAuthenticated?.() && (
        <div className='gap-y-2'>
          <p>
            <Trans>
              This is a temporary suspension of membership according to
              our&nbsp;
              <a
                href='https://www.formfactory.cz/wp-content/uploads/2025/01/2022-09_vop_ff.pdf'
                target='_blank'
                rel='noreferrer'
                className='text-secondary'
              >
                terms and conditions
              </a>
              . If you wish to cancel the membership, please contact the
              reception of your club
            </Trans>
          </p>
          <button
            type='button'
            onClick={() => navigate?.('pauseMembership')}
            className='my-3 flex shrink-0 flex-row items-center justify-center gap-1 rounded-md bg-warning/20 px-3 py-2.5 text-warning transition-all enabled:hover:scale-105 enabled:hover:opacity-70 enabled:active:scale-100'
          >
            <BadgePlus className='size-5' />
            <Trans>Pause membership</Trans>
          </button>
        </div>
      )}
    </Message.BubbleGroup>
  );
});
